import translation from "./translations.json";

const images = {
  AUTH_LOGO: require("./assets/images/authLogo.png"),
  AUTH_BACKGROUND: require("./assets/images/background.png"),
  SIDEBAR_LOGO: require("./assets/images/sidebar.png"),
  BG_1: require("./assets/bg/bg1.png"),
  BG_2: require("./assets/bg/bg2.png"),
  BG_3: require("./assets/bg/bg3.png"),
  BG_4: require("./assets/bg/bg4.png"),
  BG_5: require("./assets/bg/bg5.png"),
  BG_6: require("./assets/bg/bg6.png"),
};

const lightColors = {
  "--color-primary": "#e10245",
  "--color-secondary": "#101641",
  "--color-tertiary": "#1b75bc",
  "--color-white": "#ffffff",
  "--background-50": "#101641",
  "--background-100": "#1b75bc",
  "--background-200": "#e10245",
  "--background-300": "#4fa0e6",
  "--background-400": "#4fa0e6",
  "--background-500": "#4fa0e6",
  "--background-600": "#4fa0e6",
  "--background-700": "#4fa0e6",
  "--background-800": "#f2f2f2",
  "--background-900": "#ffffff",
  "--background-950": "#101641",
};

const darkColors = {
  "--color-primary": "#ff4d6a",
  "--color-secondary": "#4fa0e6",
  "--color-tertiary": "#1b75bc",
  "--color-white": "#ffffff",
  "--background-50": "#101641",
  "--background-100": "#1b75bc",
  "--background-200": "#e10245",
  "--background-300": "#4fa0e6",
  "--background-400": "#4fa0e6",
  "--background-500": "#4fa0e6",
  "--background-600": "#4fa0e6",
  "--background-700": "#4fa0e6",
  "--background-800": "#f2f2f2",
  "--background-900": "#ffffff",
  "--background-950": "#101641",
};

const colors = {
  light: lightColors,
  dark: darkColors,
};

const translations = translation;

const links = {
  support: "https://www.atomservices.io/contact#SUPPORT",
  contact: "https://www.atomservices.io/contact",
  privacyPolicy: "https://www.atomservices.io/privacy-policy",
  terms: "https://www.atomservices.io/terms-and-conditions",
};

const platform = "thermocloud";

export const thermocloud = {
  images,
  colors,
  translations,
  links,
  platform,
  availableReports: [1, 4, 7, 8, 9], // All reports available, adjust as needed
};
